import React, { useContext } from 'react';
import { useSelector } from 'react-redux';

import { PopupContext } from '@app/dev/contexts/popup';
import { useTranslation } from '@common/hooks/translation';
import { POPUPS } from '@common/constants/popups';

export const VerificationInfo = () => {
  const t = useTranslation();
  const [{ openPopup }] = useContext(PopupContext);
  const verification = useSelector((state) => state.terminal.verification);

  if (verification.isVerified) {
    return (
      <div className="verified">
        <i className="global-icon icon-verification" />
        <p>{t('Verified')}</p>
      </div>
    );
  }

  return (
    <div className="passportVerification" onClick={() => openPopup(POPUPS.PASSPORT_VERIFICATION)}>
      <i className="global-icon icon-verification" />
      <p>
        {t('Verification required to topup balance')}
        !
      </p>
    </div>
  );
};
